export class Vendor {
    id!: number
    name!: string
    isRental!: boolean
    isAggregate!: boolean
    isConcrete!: boolean
    isPumpTruck!: boolean
    isConcreteTester!: boolean
    isSawCutter!: boolean
    isCrane!: boolean
    isLessor!: boolean
}
